import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PitComplianceService } from '../../pit-compliance.service';


@Component({
  selector: 'app-notradeconfirmation',
  templateUrl: './notradeconfirmation.component.html',
  styleUrls: ['./notradeconfirmation.component.scss']
})
export class NotradeconfirmationComponent implements OnInit {
  @Input() preclearancedata;
  public active1 = 1;
  pdfFormTrading: FormGroup;
  getIdDp: any;
  getformTypes: any;
  companyName: any;
  isinNumber: any;
  getStatus: any;
  complianceofficerdesignation: any;
  complianceofficername: any;
  complianceOfficerEmail: any;
  isLoading = false;
  button = 'Yes';
    constructor(
      public activeModal: NgbActiveModal, private router:Router, private fb: FormBuilder, private toastr: ToastrService,
     private pitService: PitComplianceService ) { }

  ngOnInit() {
    this.getIdDp = this.preclearancedata.id;
    this.getStatus = this.preclearancedata.status;

  }
 tradingConfirmation(){
  let preId = {'id' : this.preclearancedata.id};
   this.isLoading = true;
      this.button = 'Processing';
      
  this.pitService.noTradeRetrive(preId).subscribe(
        (data) =>{ 
    this.toastr.success(data.message);
    this.isLoading = false;
      this.button = 'Yes';
    this.pitService.notradeRetrivemailconfig(this.preclearancedata).subscribe(data =>{ });

     //window.location.reload();
    
  })
 }
  closeModal(sendData) {
    this.activeModal.close(sendData);
  }

}
